import { bankService } from '@/services';
export default {
    async requestBankDeposit({ commit }, payload = {}) {
        const { serialNumber = '', depositBaromoney = '', } = payload;
        const response = await bankService.requestBankDeposit({
            serialNumber,
            depositBaromoney,
        });
        commit('SET_BANK_DATA', response.data);
        return response.data;
    },
    async getVirtualBank({ commit }) {
        const response = await bankService.getVirtualBank();
        commit('SET_VIRTUAL_BANK', response.data.virtualBank);
        return response.data;
    },
    async setVirtualBank({ commit }) {
        commit('SET_VIRTUAL_BANK', null);
    },
};
